import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ComponentsModule } from '@campus/components';
import { ScopedPaletteDirective } from '@campus/features/theming/scoped-palette';
import { SvgModule } from '@campus/svg';
import { ThemingModule } from '@campus/theming';
import { UiModule } from '@campus/ui';
import { AssessmentComponent } from './components/assessment/assessment.component';
import { LearnosityAuthorComponent } from './components/author/author.component';
import { FreshworksComponent } from './components/freshworks/freshworks.component';
import { GradingComponent } from './components/grading/grading.component';
import { LearnosityDialogComponent } from './components/learnosity-dialog/learnosity-dialog.component';
import { LearnosityOverlayComponent } from './components/learnosity-overlay/learnosity-overlay.component';
import { ReportingComponent } from './components/reporting/reporting.component';
import { icons } from './icons';
import { dcrIconService } from '@diekeure/dcr-components';
import { dcrIcons } from './dcr-icons';

dcrIconService.registerIcons(dcrIcons);

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    ComponentsModule,
    ThemingModule,
    ScopedPaletteDirective,
    SvgModule.forRoot({
      iconMapping: icons,
    }),
  ],
  declarations: [
    AssessmentComponent,
    ReportingComponent,
    LearnosityAuthorComponent,
    LearnosityDialogComponent,
    LearnosityOverlayComponent,
    FreshworksComponent,
    GradingComponent,
  ],
  exports: [AssessmentComponent, ReportingComponent, LearnosityAuthorComponent, LearnosityOverlayComponent, FreshworksComponent, GradingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LearnosityModule {}
